import Vue from 'vue';
import Vuex from 'vuex';

import schedulerApi from '@/api/scheduler-api';
import moment from 'moment';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: false,    
    person: {
      firstName: "",
      lastName: "",
      memberIdentifier: '',
      phoneNumber: '',
      email: '',
      address: '',
      address2: '',
      city: '',
      state: '',
      zipCode: '',   
      licenseNumber: '',         
    },       
    paymentToken: '',     
    locationId: '',
    locationString: '',
    transactionDetails: {},
    appointmentType: '',
    appointmentTime: '',
    appointmentDate: null,        
    processingTransaction: false,    
    retrievingAppointments: false,
    retrievingServices: false,
    error: '',
    availableAppointmentTimes: [],
    schedulingAppointment: false,   
    verifyingMembership: false, 
    isMember: false,
    appointmentId: '',
    locations: [],
    services: [],
    selectedService: '',
    selectedServiceDescription: '',
    selectedBranch: '',
    selectedPerson: '',
    notes: '',
  },
  getters: {
    availableLocations: state => {
      return state.locations.filter(function(location) {
          var idx = location.availableServices.findIndex(s => state.selectedService == s.coreId);                              
          if(idx > -1) {
            return location;
          }                  
      });
    },
    availablePeople: state => {
      let toReturn = [];
      toReturn.push({ name: 'Anyone', id: 'Anyone'});      
      state.locations.forEach(function(location) {
        if(location && location.availableServices && location.id === state.locationId) {
          var idx = location.availableServices.findIndex(s => state.selectedService == s.coreId);
          if(idx > -1 && location.availableServices[idx].availableStaff) {
            location.availableServices[idx].availableStaff.forEach(function(staff) {
              let toAdd = {};
              toAdd.name = staff.lastName;
              toAdd.id = staff.lastName;

              var idxCheck = toReturn.findIndex(s => s.id == toAdd.id);
              if(idxCheck === -1) {
                toReturn.push(toAdd);
              }
            });
          }
        }
      });

      return toReturn;
    }
  },
  mutations: {        
    resetData(state) {
      state.appointmentDate = null;
      state.appointmentTime = '';
      state.appointmentType = '';
      state.person = {
        firstName: "",
        lastName: "",
        memberIdentifier: '',
        phoneNumber: '',
        email: '',
        address: '',
        address2: '',
        city: '',
        state: '',
        zipCode: '',   
        licenseNumber: '',                 
      };
      state.paymentToken = '';
      state.locationId = '';
      state.locationString = '';
      state.transactionDetails = {};
      state.isMember = false;
      state.error = '';      
      state.appointmentId = '';
      state.notes = '';
    },
    setAppointmentId(state, id) {
      state.appointmentId = id;
    },
    setAppointmentType(state, type) {
      state.appointmentType = type;
    },    
    setLocation(state, location) {
      state.locationId = location.id;
      state.locationString = location.name;
    },    
    setAppointment(state, appointment) {
      state.appointment = appointment;
      console.info('Appointment Set: ', state.appointment);
    },     
    setError(state, error) {
      state.error = error;
    },
    setFirstName(state, val) {      
      state.person.firstName = val;
    },
    setLastName(state, val) {
      state.person.lastName = val;
    },
    setAddress(state, val) {
      state.person.address = val;
    },
    setCity(state, val) {
      state.person.city = val;
    },
    setState(state, val) {
      state.person.state = val;
    },
    setZipCode(state, val) {
      state.person.zipCode = val;
    },
    setLicenseNumber(state, val) {
      state.person.licenseNumber = val;
    },
    setMemberIdentifier(state, val) {
      state.person.memberIdentifier = val;
      console.info('member identifier', val);
      if(val != 0) {
        state.isMember = true;
      } else {
        state.isMember = false; 
      }
    },
    setPhoneNumber(state, val) {
      state.person.phoneNumber = val;      
    },
    setEmailAddress(state, val) {
      state.person.email = val;
    },
    setPaymentToken(state, val) {
      state.paymentToken = val;
    },
    setRetrievingAppointments(state, val) {
      state.retrievingAppointments = val;
    },
    setAvailableTimes(state, times) {
      state.availableAppointmentTimes = times;
    },
    setAppointmentTime(state, time) {      
      /*let appointmentActual = new moment(state.appointmentDate);
      let fixedTime = moment(appointmentActual.format("MM/DD/YYYY")  + ' ' + time, 'MM/DD/YYYY hh:mmA');
      console.log('fixed time', fixedTime);
      state.appointmentTime = fixedTime;      */
      state.appointmentTime = time;
    },
    setAppointmentDate(state, date) {
      state.appointmentDate = date;
    },
    setAppointmentLocation(state, location) {
      state.appointmentLocation = location
    },
    setSchedulingAppointment(state, val) {
      state.schedulingAppointment = val;
    },
    setVerifyingMembership(state, val) {
      state.verifyingMembership = val;
    },
    setLocations(state, val) {
      state.locations = val;
      
      state.services = [];
      let servicesArray = [];
      for(var i = 0; i < val.length; i++) {        
        if(val[i].id === 102) {
          val[i].name = 'Downtown Shelton Branch';
        } else if(val[i].id === 106) {
          val[i].name = 'Mt View Shelton Branch';
        } else {
          val[i].name = val[i].name.substring(0, val[i].name.length - 3);
        }
        
        let services = val[i].availableServices;
        if(services.length > 0) {
          for(var j = 0; j < services.length; j++) {
            var idx = servicesArray.findIndex(s => services[j].coreId == s.coreId);
            if(idx === -1) {
              servicesArray.push(services[j]);
            }
          }
        }        
      }
      servicesArray.push({ coreId: 'REALESTATE', description: 'Mortgage/HELOC/Land Loans' })
      
      state.services = servicesArray;
    },
    setRetrievingServices(state, val) {
      state.retrievingServices = val;
    },
    setSelectedService(state, val) {
      state.selectedService = val;
    },
    setSelectedServiceDescription(state, val) {
      state.selectedServiceDescription = val;
    },
    setSelectedBranch(state, val) {
      state.selectedBranch = val;
    },
    setSelectedPerson(state, val) {
      state.selectedPerson = val;
    },
    setNotes(state, val) {
      state.notes = val;
    }
  },
  actions: {    
    async getAppointmentTimes(context, { date }) {
      await context.commit('setRetrievingAppointments', true);     
      let appointmentTimes = await schedulerApi.getAppointmentTimesByDate(context.state.locationId, date, context.state.selectedService);
      let fixedAppointmentTimes = [];
      for(var i = 0; i < appointmentTimes.length; i++) {
        var timeStr = new moment(appointmentTimes[i]).format("hh:mmA");
        fixedAppointmentTimes.push(timeStr);
      }
      await context.commit('setAvailableTimes', fixedAppointmentTimes);
      await context.commit('setRetrievingAppointments', false);     
      return appointmentTimes;
    },
    async scheduleAppointment(context) {
      await context.commit('setSchedulingAppointment', true);                       

      let appointmentActual = new moment(context.state.appointmentDate);
      let fixedTime = moment.utc(appointmentActual.format("MM/DD/YYYY")  + ' ' + context.state.appointmentTime, 'MM/DD/YYYY hh:mmA');
      console.log('fixed time', fixedTime);         
      
      let appointment = await schedulerApi.scheduleAppointment(context.state.person, fixedTime.toDate(), context.state.locationId, context.state.selectedService, context.state.selectedServiceDescription, context.state.selectedPerson, context.state.notes);

      await context.commit('setSchedulingAppointment', false);
      
      console.info('appt returned', appointment);
      return appointment;
    },
    async verifyMembership(context) {
      await context.commit('setVerifyingMembership', true);

      let memberIdentifier = await schedulerApi.verifyMembership(context.state.person);

      await context.commit('setMemberIdentifier', memberIdentifier);

      await context.commit('setVerifyingMembership', false);
    },
    async changeAppointment(context) {
      let appointment = await schedulerApi.changeAppointment(context.state.appointmentId, context.state.appointmentTime.toDate(), context.state.locationId);

      return appointment;
    },
    async getLocations(context) {
      await context.commit('setRetrievingServices', true);
      let locations = await schedulerApi.getLocations();      

      await context.commit('setLocations', locations);
      console.info('locations in store', locations);
      await context.commit('setRetrievingServices', false);
    }
  }
})
